/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Jump_CtaInputs */

const en_features_jump_cta = /** @type {(inputs: Features_Jump_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give it a try`)
};

const es_features_jump_cta = /** @type {(inputs: Features_Jump_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pruébalo`)
};

/**
* | output |
* | --- |
* | "Give it a try" |
*
* @param {Features_Jump_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_jump_cta = /** @type {((inputs?: Features_Jump_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Jump_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_jump_cta(inputs)
	return en_features_jump_cta(inputs)
});